import { createSelector } from '@reduxjs/toolkit';
import type { SapSyncState } from './sap-sync.slice';
import { CIRCUIT_BREAKER_STATE } from '../domain/constants';

type RootState = { sapSync: SapSyncState };

const selectSapSyncState = (state: RootState) => state.sapSync;

export const selectDashboard = createSelector(
  selectSapSyncState,
  (state) => state.dashboard,
);

export const selectSyncJobs = createSelector(
  selectSapSyncState,
  (state) => state.syncJobs,
);

export const selectDlqEntries = createSelector(
  selectSapSyncState,
  (state) => state.dlqEntries,
);

export const selectSapSyncLoading = createSelector(
  selectSapSyncState,
  (state) => state.loading,
);

export const selectSapSyncError = createSelector(
  selectSapSyncState,
  (state) => state.error,
);

export const selectSapSyncFilter = createSelector(
  selectSapSyncState,
  (state) => state.filter,
);

export const selectSelectedJob = createSelector(
  selectSapSyncState,
  (state) => state.selectedJob,
);

export const selectCircuitBreakerStatus = createSelector(
  selectDashboard,
  (dashboard) => dashboard?.circuitBreaker ?? null,
);

export const selectIsCircuitOpen = createSelector(
  selectCircuitBreakerStatus,
  (cb) => cb?.state === CIRCUIT_BREAKER_STATE.OPEN,
);

export const selectDlqDepth = createSelector(
  selectDashboard,
  (dashboard) => dashboard?.dlqDepth ?? 0,
);

export const selectPullWatermarks = createSelector(
  selectDashboard,
  (dashboard) => dashboard?.pullWatermarks ?? [],
);

export const selectSyncJobStats = createSelector(
  selectDashboard,
  (dashboard) => dashboard?.syncJobStats ?? {},
);

export const selectSyncJobsPagination = createSelector(
  selectSapSyncState,
  (state) => state.pagination,
);
